export const CLIENT = '@@exceptions/CLIENT'
export const SERVICE_UNAVAILABLE = '@@exceptions/SERVICE_UNAVAILABLE'

// api triodos exceptions
export const URL_NOT_FOUND = 't000'
export const REQUEST_NOT_FOUND = 't001'
export const DOCUMENT_ALREADY_UPLOADED = 't002'
export const VALIDATION_BODY_ERROR = 't003'
export const USER_NOT_BELONGS_TO_REQUEST = 't004'
export const INVALID_MIME_TYPE = 't005'
export const DOCUMENT_INFO_MISSING = 't006'
export const DOCUMENTS_CHECK_FAILING = 't007'
export const HACIENDA_PARSING_ERROR = 't008'
